// Public aggregation seam for conditional features (feature-flag-gated code).
//
// Permanent registries import from here rather than from individual flag modules,
// so a flag's whole footprint is its own module plus its one line below. Tearing
// a flag down means deleting its module and removing its line here.

import type { AppFeatures } from '@/modules/config';
import type { TopicTypeId } from '@/modules/topic/types';
import { newsEnabledTopicTypeIds } from './news_topic_type_enabled';

/**
 * Action type ids enabled by conditional features for the given runtime config,
 * consumed by the permanent action-type registry
 * (`@/modules/topic/topicTypeRegistry`). Each flag that gates an action type
 * contributes one entry here.
 */
export function conditionalEnabledTopicTypeIds(
  features: AppFeatures
): TopicTypeId[] {
  return [...newsEnabledTopicTypeIds(features)];
}
